import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import SavePassword from '@ridango/core/lib/services/save-password.plugin';

@Injectable({
    providedIn: 'root'
})
export class SavePasswordService {
    constructor() {
        // do nothing
    }

    // trigger IOS prompt to save credentials
    public promptSaveCredentials(email: string, password: string): Promise<void> {
        if (Capacitor.getPlatform() === 'ios') {
            return SavePassword.promptDialog({
                username: email,
                password: password
            });
        }

        return Promise.resolve();
    }
}
